import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { baseURL } from "../../../API/API";
import { toast } from "react-toastify";
import Lodingsubmit from "../../Loding/Loding";
import "./Content.css";

const packageTypes = [
  { value: "term1", label: "ترم أول" },
  { value: "term2", label: "ترم ثاني" },
  { value: "year", label: "سنة كاملة" },
];

const readApiError = (err) => {
  const message = err.response?.data?.message;
  const errors = err.response?.data?.errors;
  if (errors) {
    const first = Object.values(errors).flat().filter(Boolean)[0];
    return first || message || "حدث خطأ أثناء حفظ الباقة";
  }
  return message || "حدث خطأ أثناء حفظ الباقة";
};

const normalizeChapter = (chapter = {}) => ({
  ...chapter,
  id: Number(chapter.id),
  name: chapter.name || chapter.chapterName || "",
  price: Number(chapter.price ?? chapter.chapterPrice ?? 0),
  discount: Number(chapter.discount ?? 0),
  academic_year_id: chapter.academic_year_id ?? chapter.academicYearId ?? chapter.academicYear?.id ?? chapter.academicYear ?? "",
  academic_year_name: chapter.academic_year_name || chapter.academicYear?.name || (typeof chapter.academicYear === "string" ? chapter.academicYear : ""),
  teacher_id: chapter.teacher_id ?? chapter.teacher?.id ?? chapter.teacherId ?? null,
  teacher_name: chapter.teacher_name || chapter.teacher?.name || "",
});

export default function CoursePackageForm({ mode = "add" }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(false);
  const [baseLoading, setBaseLoading] = useState(true);
  const [academics, setAcademics] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [selectedTeacherChapters, setSelectedTeacherChapters] = useState([]);
  const [teacherChaptersLoading, setTeacherChaptersLoading] = useState(false);
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [form, setForm] = useState({
    name: "",
    package_type: "term1",
    academic_year_id: "",
    teacher_id: "",
    price: "",
    discount: "0",
    vodafone_cash: "",
    instapay: "",
    description: "",
    save: false,
  });
  const [image, setImage] = useState(null);

  useEffect(() => {
    async function loadBaseData() {
      setBaseLoading(true);
      try {
        const [academicRes, teacherRes, chaptersRes] = await Promise.all([
          axiosPrivate.get(`${baseURL}/learning/academics`),
          axiosPrivate.get(`${baseURL}/learning/teachers`, { params: { include_admin: 1 } }),
          axiosPrivate.get(`${baseURL}/learning/chapters/all`),
        ]);
        setAcademics(academicRes.data?.data || []);
        setTeachers(teacherRes.data?.data || []);
        setChapters((chaptersRes.data?.data || []).map(normalizeChapter));
      } catch (err) {
        toast.error(err.response?.data?.message || "فشل تحميل بيانات الباقة");
      } finally {
        setBaseLoading(false);
      }
    }
    loadBaseData();
  }, [axiosPrivate]);

  useEffect(() => {
    if (mode !== "edit" || !id) return;
    async function loadPackage() {
      setLoading(true);
      try {
        const res = await axiosPrivate.get(`${baseURL}/learning/packages/detail/${id}`);
        const pkg = res.data?.data || {};
        setForm({
          name: pkg.name || "",
          package_type: pkg.package_type === "term" ? "term1" : (pkg.package_type || "term1"),
          academic_year_id: pkg.academic_year_id || "",
          teacher_id: pkg.is_platform_teacher ? "admin" : (pkg.teacher_id || ""),
          price: pkg.price || "",
          discount: pkg.discount || "0",
          vodafone_cash: pkg.vodafone_cash || "",
          instapay: pkg.instapay || "",
          description: pkg.description || "",
          save: Boolean(pkg.is_draft),
        });
        setSelectedChapters((pkg.chapters || []).map((ch) => ch.id));
      } catch (err) {
        toast.error(err.response?.data?.message || "فشل تحميل تفاصيل الباقة");
      } finally {
        setLoading(false);
      }
    }
    loadPackage();
  }, [axiosPrivate, id, mode]);

  const getChapterTeacherId = useCallback((chapter) => chapter.teacher_id ?? chapter.teacher?.id ?? chapter.teacherId ?? null, []);
  const isPlatformTeacherSelected = String(form.teacher_id) === "admin";
  const isPlatformChapter = useCallback((chapter) => {
    const chapterTeacherId = getChapterTeacherId(chapter);
    const teacherName = `${chapter.teacher_name || chapter.teacher?.name || ""}`;
    return chapterTeacherId === null
      || chapterTeacherId === undefined
      || chapterTeacherId === ""
      || (teacherName.includes("\u0645\u062d\u0645\u0648\u062f") && teacherName.includes("\u0635\u0628\u0631\u0648\u0637"));
  }, [getChapterTeacherId]);

  const sameYearChapters = useMemo(() => {
    if (!form.academic_year_id) return [];
    return chapters.filter((chapter) => Number(chapter.academic_year_id) === Number(form.academic_year_id));
  }, [chapters, form.academic_year_id]);

  useEffect(() => {
    setSelectedTeacherChapters([]);
    if (!form.teacher_id || !form.academic_year_id) return;

    let cancelled = false;
    setTeacherChaptersLoading(true);
    axiosPrivate.get(`${baseURL}/learning/teachers/${form.teacher_id}/chapters`, {
      params: { academic_year_id: form.academic_year_id, include_drafts: 1 },
    })
      .then((res) => {
        if (cancelled) return;
        const teacherChapters = (res.data?.data || []).map(normalizeChapter);
        setSelectedTeacherChapters(teacherChapters);
        setChapters((prev) => {
          const map = new Map(prev.map((chapter) => [Number(chapter.id), chapter]));
          teacherChapters.forEach((chapter) => map.set(Number(chapter.id), { ...map.get(Number(chapter.id)), ...chapter }));
          return Array.from(map.values());
        });
      })
      .catch((err) => {
        if (!cancelled) toast.error(err.response?.data?.message || "ÙØ´Ù„ ØªØ­Ù…ÙŠÙ„ Ø´Ù‡ÙˆØ± Ø§Ù„Ù…Ø¯Ø±Ø³");
      })
      .finally(() => {
        if (!cancelled) setTeacherChaptersLoading(false);
      });

    return () => { cancelled = true; };
  }, [axiosPrivate, form.teacher_id, form.academic_year_id]);

  const filteredChapters = useMemo(() => {
    const source = selectedTeacherChapters.length > 0 ? selectedTeacherChapters : sameYearChapters;
    return source.filter((chapter) => {
      const chapterTeacherId = getChapterTeacherId(chapter);
      if (isPlatformTeacherSelected) {
        return isPlatformChapter(chapter);
      }
      return form.teacher_id && chapterTeacherId !== null && chapterTeacherId !== undefined && String(chapterTeacherId) === String(form.teacher_id);
    });
  }, [selectedTeacherChapters, sameYearChapters, form.teacher_id, isPlatformTeacherSelected, isPlatformChapter, getChapterTeacherId]);
  const updateForm = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    if (key === "academic_year_id" || key === "teacher_id") {
      setSelectedChapters([]);
    }
  };

  const toggleChapter = (chapterId) => {
    setSelectedChapters((prev) => prev.includes(chapterId) ? prev.filter((item) => item !== chapterId) : [...prev, chapterId]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.academic_year_id || !form.teacher_id) {
      toast.warning("اختر السنة الدراسية والمدرس أولا");
      return;
    }
    if (selectedChapters.length === 0) {
      toast.warning("اختر شهر دراسي واحد على الأقل للباقة");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => formData.append(key, key === "save" ? (value ? "true" : "false") : value));
    selectedChapters.forEach((chapterId) => formData.append("chapter_ids[]", chapterId));
    if (image) formData.append("image", image);

    try {
      const endpoint = mode === "edit" ? `${baseURL}/learning/packages/update/${id}` : `${baseURL}/learning/packages/create`;
      await axiosPrivate.post(endpoint, formData);
      toast.success(mode === "edit" ? "تم تحديث الباقة بنجاح" : "تم إنشاء الباقة بنجاح");
      navigate("/DashboardLayout/packages");
    } catch (err) {
      toast.error(readApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {(loading || baseLoading) && <Lodingsubmit />}
      <div className="p-4 content" dir="rtl">
        <h2 className="fw-bold mb-5">{mode === "edit" ? "تعديل باقة ترم/سنة" : "إضافة باقة ترم/سنة"}</h2>
        <Form onSubmit={handleSubmit} className="Form w-75">
          <Form.Group className="floating-label-group mb-5">
            <Form.Control className="inpoutFeald" value={form.name} onChange={(e) => updateForm("name", e.target.value)} placeholder=" " required />
            <Form.Label>اسم الباقة</Form.Label>
          </Form.Group>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-5">
                <Form.Label>نوع الباقة</Form.Label>
                <Form.Select value={form.package_type} onChange={(e) => updateForm("package_type", e.target.value)} required>
                  {packageTypes.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-5">
                <Form.Label>السنة الدراسية</Form.Label>
                <Form.Select value={form.academic_year_id} onChange={(e) => updateForm("academic_year_id", e.target.value)} required>
                  <option value="">اختر السنة</option>
                  {academics.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-5">
                <Form.Label>المدرس</Form.Label>
                <Form.Select value={form.teacher_id} onChange={(e) => updateForm("teacher_id", e.target.value)} required>
                  <option value="">اختر المدرس</option>
                  {teachers.map((teacher) => <option key={teacher.id} value={teacher.id}>{teacher.name}</option>)}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}><Form.Group className="floating-label-group mb-5"><Form.Control className="inpoutFeald" type="number" min="0" value={form.price} onChange={(e) => updateForm("price", e.target.value)} placeholder=" " required /><Form.Label>السعر</Form.Label></Form.Group></Col>
            <Col md={6}><Form.Group className="floating-label-group mb-5"><Form.Control className="inpoutFeald" type="number" min="0" value={form.discount} onChange={(e) => updateForm("discount", e.target.value)} placeholder=" " /><Form.Label>الخصم</Form.Label></Form.Group></Col>
          </Row>

          <Form.Group className="floating-label-group mb-5"><Form.Control className="inpoutFeald" as="textarea" rows={4} value={form.description} onChange={(e) => updateForm("description", e.target.value)} placeholder=" " style={{ height: "auto", paddingTop: 25 }} /><Form.Label>وصف الباقة</Form.Label></Form.Group>

          <Row>
            <Col md={6}><Form.Group className="floating-label-group mb-5"><Form.Control className="inpoutFeald" value={form.vodafone_cash} onChange={(e) => updateForm("vodafone_cash", e.target.value)} placeholder=" " /><Form.Label>رقم فودافون كاش مخصص</Form.Label></Form.Group></Col>
            <Col md={6}><Form.Group className="floating-label-group mb-5"><Form.Control className="inpoutFeald" value={form.instapay} onChange={(e) => updateForm("instapay", e.target.value)} placeholder=" " /><Form.Label>انستا باي مخصص</Form.Label></Form.Group></Col>
          </Row>

          <Form.Group className="mb-5"><Form.Label className="fw-bold">صورة الغلاف</Form.Label><Form.Control type="file" accept="image/*" onChange={(e) => setImage(e.target.files?.[0] || null)} /></Form.Group>

          <Card className="mb-5 p-4 border shadow-sm" style={{ borderRadius: 8 }}>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <Card.Title className="fw-bold m-0 text-primary">الشهور الخاصة بنفس المدرس والسنة</Card.Title>
              <span className="badge bg-light text-dark border">المحدد: {selectedChapters.length}</span>
            </div>
            <div style={{ maxHeight: 340, overflowY: "auto" }}>
              {!form.academic_year_id || !form.teacher_id ? (
                <p className="text-muted m-0">اختر السنة والمدرس لعرض الشهور المتاحة لنفس المدرس ونفس السنة فقط.</p>
              ) : teacherChaptersLoading ? (
                <p className="text-muted m-0">Ø¬Ø§Ø±ÙŠ ØªØ­Ù…ÙŠÙ„ Ø´Ù‡ÙˆØ± Ø§Ù„Ù…Ø¯Ø±Ø³...</p>
              ) : filteredChapters.length === 0 ? (
                <div className="text-muted">
                  <p className="m-0">لا توجد شهور مطابقة لهذا المدرس في هذه السنة.</p>
                  {sameYearChapters.length > 0 && <p className="small mt-2 mb-0">يوجد {sameYearChapters.length} شهر في نفس السنة لكنهم مسجلين على مدرسين آخرين، لذلك لن يظهروا هنا.</p>}
                </div>
              ) : (
                <Row className="g-3">
                  {filteredChapters.map((chapter) => (
                    <Col md={6} key={chapter.id}>
                      <label className="d-flex align-items-start gap-2 border rounded p-3 h-100" style={{ cursor: "pointer", borderColor: selectedChapters.includes(chapter.id) ? "var(--brand-300)" : "#dee2e6" }}>
                        <Form.Check type="checkbox" id={`package-ch-${chapter.id}`} checked={selectedChapters.includes(chapter.id)} onChange={() => toggleChapter(chapter.id)} />
                        <div>
                          <div className="fw-bold">{chapter.name}</div>
                          <div className="text-muted small">{Number(chapter.price || 0).toFixed(0)} ج.م{isPlatformChapter(chapter) && !getChapterTeacherId(chapter) ? " - أدمن المنصة" : ""}</div>
                        </div>
                      </label>
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          </Card>

          <Form.Group className="mb-5"><Form.Check type="checkbox" label="حفظ كمسودة" checked={form.save} onChange={(e) => updateForm("save", e.target.checked)} /></Form.Group>
          <Button type="submit" disabled={loading || baseLoading} className="custom-brand-btn-dhash px-5 py-2">حفظ الباقة</Button>
        </Form>
      </div>
    </>
  );
}

